/*************************** 工具函数类 ***************************/
import moment from 'moment';
import store from '@/store/index';

moment.locale('en');

/**
 * @Description:
 * [通过参数名获取url中的参数值]
 * @param  {[string]} queryName [参数名]
 * @return {[string]}           [参数值]
 */
export const getQueryString = function(queryName) {
    let reg = new RegExp('(^|&)' + queryName + '=([^&]*)(&|$)', 'i');
    let r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return decodeURIComponent(r[2]);
    } else {
        return null;
    }
};

/**
 * @Description:
 * [获取url中的参数对象]
 * @return {[string]}  [参数对象]
 */
export const getParams = function() {
    let r = window.location.search.substr(1).split('&');
    let obj = {};
    r.forEach(item => {
        item = item.split('=');
        obj[item[0]] = item[1];
    });
    return obj;
};

/**
 *
 * @param {*} fmt 格式 date 时间
 * @description 日期格式化
 * 月(M)、日(d)、小时(H)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * 例子：
 * (new Date()).Format("yyyy-MM-dd HH:mm:ss.S") ==> 2006-07-02 08:09:04.423
 * (new Date()).Format("yyyy-M-d H:m:s.S")      ==> 2006-7-2 8:9:4.18
 */
export const format = function(fmt, date) {
    let o = {
        'M+': date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'h+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    for (let k in o)
        if (new RegExp('(' + k + ')').test(fmt))
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
            );
    return fmt;
};


/**
 * 通过时间计算出年龄
 * yyyy-mm-dd
 *
 */
export const getAge = putDate => {
    if (!putDate) {
        return '';
    }
    // 根据出生日期算出年龄*/
    let returnAge;
    let strBirthdayArr = putDate.split('-');
    let birthYear = strBirthdayArr[0];
    let birthMonth = strBirthdayArr[1];
    let birthDay = strBirthdayArr[2];
    let d = new Date();
    let nowYear = d.getFullYear();
    let nowMonth = d.getMonth() + 1;
    let nowDay = d.getDate();
    if (nowYear === +birthYear) {
        returnAge = 0; // 同年 则为0岁
    } else {
        let ageDiff = nowYear - birthYear; // 年之差
        if (ageDiff > 0) {
            if (nowMonth === +birthMonth) {
                let dayDiff = nowDay - birthDay; // 日之差
                if (dayDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            } else {
                let monthDiff = nowMonth - birthMonth; // 月之差
                if (monthDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            }
        } else {
            returnAge = -1; // 返回-1 表示出生日期输入错误 晚于今天
        }
    }
    return Number(returnAge); // 返回周岁年龄
};


// 将 5年，10年，截取其中的数字
export const setYear = function(data, age) {
    if (data.indexOf('周岁') != -1) {
        return data.replace(/[^0-9]/gi, '') - age;
    } else if (data.indexOf('年') != -1) {
        return data.replace(/[^0-9]/gi, '');
    } else {
        return parseInt(data);
    }
};

// 获取两者之间的时间差
export const days = function(sDate1, sDate2) {
    let aDate, oDate1, oDate2, iDays;

    let u = navigator.userAgent;
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isIOS) {
        //这个是安卓操作系统
        aDate = sDate1.split('-');
        oDate1 = new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0]); //转换为12-18-2002格式
        aDate = sDate2.split('-');
        oDate2 = new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0]);
        iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24); //把
    } else {
        aDate = sDate1.split('-');
        oDate1 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0]); //转换为12-18-2002格式
        aDate = sDate2.split('-');
        oDate2 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0]);
        iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24); //把
    }

    return iDays + 1;
};

// 判断是否是ios端
export function isIOS() {
    let isIphone = navigator.userAgent.includes('iPhone');
    let isIpad = navigator.userAgent.includes('iPad');
    return isIphone || isIpad;
}

// 根据身份证计算性别
export const getSex = function(val) {
    let sex;
    if (val.length == 15) {
        sex = val.substring(13, 14);
        if (sex % 2 === 0) {
            return '女';
        } else {
            return '男';
        }
    } else if (val.length === 18) {
        sex = val.substring(16, 17);
        if (sex % 2 === 0) {
            return '女';
        } else {
            return '男';
        }
    }
};

export const getSexcode = function(val) {
    let sex;
    if (val.length == 15) {
        sex = val.substring(13, 14);
        if (sex % 2 === 0) {
            return '1';
        } else {
            return '0';
        }
    } else if (val.length === 18) {
        sex = val.substring(16, 17);
        if (sex % 2 === 0) {
            return '1';
        } else {
            return '0';
        }
    }
};

export const getMaxDate = function(vals) {
    let val = getAge(vals);
    if (val < 17) {
        console.log('5年');
        return 5;
    }
    if (val > 16 && val < 25) {
        console.log('10年');
        return 10;
    }
    if (val > 25 && val < 45) {
        console.log('20年');
        return 20;
    }
    if (val > 45) {
        console.log('20年', '长期');
        return '长期';
    }
};

// 去掉地址参数
export const removeUrlParams = (url, arr) => {
    arr.forEach(item => {
        let reg = new RegExp(`&${item}=[^&]*`, 'gm');
        url = url.replace(reg, '');
    });
    return url;
};

/**
 * 函数节流
 * @param {Function} fn 需要节流的函数
 * @param {Number} t 节流时间
 * @returns {Function}
 * @constructor
 * @description 函数节流，限制一定时间内只能执行一次
 */
export const Throttle = (fn, t = 500) => {
    let last;
    let timer;
    let interval = t;
    return function() {
        let args = arguments;
        let now = +new Date();
        if (last && now - last < interval) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                last = now;
                fn.apply(this, args);
            }, interval);
        } else {
            last = now;
            fn.apply(this, args);
        }
    };
};

// 输入框中的值去除空格
export function trimSpace(value) {
    // 过滤输入的数字
    return value.replace(/\s*/g, '');
}

/**
 * 验证手机号码格式是否正确
 * @param {手机号码} number
 * @returns
 */
export const isPhone = number => {
    let reg = /^[1][3-9][0-9]{9}$/;
    if (!number) return;
    if (reg.test(number)) {
        return true;
    }
    if (!reg.test(number)) {
        return false;
    }
};
export const openGlobalMask = () => {
    // 打开遮罩
    store.commit('app/GLOBALMASK_OPEN');
};
export const closeGlobalMask = () => {
    // 关闭遮罩
    store.commit('app/GLOBALMASK_CLOSE');
};
export const getLocalTime = nS => {
    // 关闭遮罩
    return new Date(parseInt(nS));
};

//根据出生日期算出年龄
export const GetAge = strBirthday => {
    let returnAge,
        strBirthdayArr = strBirthday.split('-'),
        birthYear = strBirthdayArr[0],
        birthMonth = strBirthdayArr[1],
        birthDay = strBirthdayArr[2],
        d = new Date(),
        nowYear = d.getFullYear(),
        nowMonth = d.getMonth() + 1,
        nowDay = d.getDate();
    if (nowYear == birthYear) {
        returnAge = 0; //同年 则为0周岁
    } else {
        let ageDiff = nowYear - birthYear; //年之差
        if (ageDiff > 0) {
            if (nowMonth == birthMonth) {
                let dayDiff = nowDay - birthDay; //日之差
                if (dayDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            } else {
                let monthDiff = nowMonth - birthMonth; //月之差
                if (monthDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            }
        } else {
            returnAge = -1; //返回-1 表示出生日期输入错误 晚于今天
        }
    }
    return returnAge; //返回周岁年龄
};
